__turbopack_context__.v({
  "actions": "RecommendationPage-module-scss-module__owPVmW__actions",
  "active": "RecommendationPage-module-scss-module__owPVmW__active",
  "arrow": "RecommendationPage-module-scss-module__owPVmW__arrow",
  "backButton": "RecommendationPage-module-scss-module__owPVmW__backButton",
  "browseResults": "RecommendationPage-module-scss-module__owPVmW__browseResults",
  "browseResultsContainer": "RecommendationPage-module-scss-module__owPVmW__browseResultsContainer",
  "browseWrapper": "RecommendationPage-module-scss-module__owPVmW__browseWrapper",
  "checkboxForm": "RecommendationPage-module-scss-module__owPVmW__checkboxForm",
  "chip": "RecommendationPage-module-scss-module__owPVmW__chip",
  "fade": "RecommendationPage-module-scss-module__owPVmW__fade",
  "fade-slide": "RecommendationPage-module-scss-module__owPVmW__fade-slide",
  "fadeIn": "RecommendationPage-module-scss-module__owPVmW__fadeIn",
  "filter": "RecommendationPage-module-scss-module__owPVmW__filter",
  "filterButton": "RecommendationPage-module-scss-module__owPVmW__filterButton",
  "filterContainer": "RecommendationPage-module-scss-module__owPVmW__filterContainer",
  "filterHeader": "RecommendationPage-module-scss-module__owPVmW__filterHeader",
  "filterPanel": "RecommendationPage-module-scss-module__owPVmW__filterPanel",
  "filterPanelActions": "RecommendationPage-module-scss-module__owPVmW__filterPanelActions",
  "filterPanelApply": "RecommendationPage-module-scss-module__owPVmW__filterPanelApply",
  "filterPanelClose": "RecommendationPage-module-scss-module__owPVmW__filterPanelClose",
  "filterPanelContent": "RecommendationPage-module-scss-module__owPVmW__filterPanelContent",
  "filterPanelHeader": "RecommendationPage-module-scss-module__owPVmW__filterPanelHeader",
  "filterPanelOpen": "RecommendationPage-module-scss-module__owPVmW__filterPanelOpen",
  "filterPanelOverlay": "RecommendationPage-module-scss-module__owPVmW__filterPanelOverlay",
  "filterPanelTitle": "RecommendationPage-module-scss-module__owPVmW__filterPanelTitle",
  "filterWrapper": "RecommendationPage-module-scss-module__owPVmW__filterWrapper",
  "headerContainer": "RecommendationPage-module-scss-module__owPVmW__headerContainer",
  "open": "RecommendationPage-module-scss-module__owPVmW__open",
  "open-from-center": "RecommendationPage-module-scss-module__owPVmW__open-from-center",
  "planTab": "RecommendationPage-module-scss-module__owPVmW__planTab",
  "planTabs": "RecommendationPage-module-scss-module__owPVmW__planTabs",
  "planTabsContainer": "RecommendationPage-module-scss-module__owPVmW__planTabsContainer",
  "planTabsMobileDropdown": "RecommendationPage-module-scss-module__owPVmW__planTabsMobileDropdown",
  "planTypeButton": "RecommendationPage-module-scss-module__owPVmW__planTypeButton",
  "planTypeDropdown": "RecommendationPage-module-scss-module__owPVmW__planTypeDropdown",
  "planTypeList": "RecommendationPage-module-scss-module__owPVmW__planTypeList",
  "planTypeOption": "RecommendationPage-module-scss-module__owPVmW__planTypeOption",
  "planYearLabel": "RecommendationPage-module-scss-module__owPVmW__planYearLabel",
  "planYearToggle": "RecommendationPage-module-scss-module__owPVmW__planYearToggle",
  "plansContainer": "RecommendationPage-module-scss-module__owPVmW__plansContainer",
  "resetBtn": "RecommendationPage-module-scss-module__owPVmW__resetBtn",
  "resetFiltersBtn": "RecommendationPage-module-scss-module__owPVmW__resetFiltersBtn",
  "resultsSummary": "RecommendationPage-module-scss-module__owPVmW__resultsSummary",
  "selected": "RecommendationPage-module-scss-module__owPVmW__selected",
  "selections": "RecommendationPage-module-scss-module__owPVmW__selections",
  "selectionsHeader": "RecommendationPage-module-scss-module__owPVmW__selectionsHeader",
  "sort": "RecommendationPage-module-scss-module__owPVmW__sort",
  "sortButton": "RecommendationPage-module-scss-module__owPVmW__sortButton",
  "sortButtonLabel": "RecommendationPage-module-scss-module__owPVmW__sortButtonLabel",
  "sortButtonMobileLabel": "RecommendationPage-module-scss-module__owPVmW__sortButtonMobileLabel",
  "sortDropdown": "RecommendationPage-module-scss-module__owPVmW__sortDropdown",
  "sortList": "RecommendationPage-module-scss-module__owPVmW__sortList",
  "sortOption": "RecommendationPage-module-scss-module__owPVmW__sortOption",
  "spin": "RecommendationPage-module-scss-module__owPVmW__spin",
  "title": "RecommendationPage-module-scss-module__owPVmW__title",
  "toggleOption": "RecommendationPage-module-scss-module__owPVmW__toggleOption",
  "toggleSwitch": "RecommendationPage-module-scss-module__owPVmW__toggleSwitch",
});
